module.exports = __webpack_public_path__ + "img/fortinet_280x120.dd4faaf1.svg";